import { useState } from "react";

const PhoneView = ({ previewUrl, reloadPrev }) => {
  const [loading, setLoadingPreview] = useState(true);

  const handleIframeLoad = () => {
    setLoadingPreview(false);
  };

  return (
    <div className="view_body_item">
      {loading && (
        <div className="loading-bar-container">
          <div className="loading-bar" />
        </div>
      )}
      <div className="phone_preview">
        <iframe
          className="fade-in"
          src={previewUrl}
          sandbox="allow-scripts allow-same-origin"
          style={{ width: "100%", height: "100%", border: "none" }}
          title="Project Preview"
          onLoad={handleIframeLoad}
        />
      </div>
    </div>
  );
};

export default PhoneView;
